export const workTypeConstants = [
  { name: "On Site", value: "On Site" },
  { name: "Remote", value: "Remote" },
  { name: "Hybrid", value: "Hybrid" },
];
